<template>
  <div>
    <search-form
      :model="searchParams"
      :col="3"
      :items="searchConfigList"
      :loading="loading"
      inline
      :action-block="false"
      label-width="100px"
      @submit="handleSearch"
    ></search-form>

    <br>

    <section class="table-control">
      <el-button type="primary" @click="handleShowBatchRight">批量权利处理</el-button>
    </section>
    <el-table v-loading="loading" :data="tableData">
      <el-table-column label="申诉子单号" width="125" prop="subApplicationOrder"></el-table-column>
      <el-table-column label="匹配结果ID" width="125" prop="pkId"></el-table-column>
      <el-table-column label="申诉歌单ID" prop="tracklistId" width="125"></el-table-column>
      <el-table-column label="申诉子状态" width="100" v-slot="{ row }">
        {{ appealSubStatusMap[row.subStatus] }}
      </el-table-column>
      <el-table-column label="授权方信息" prop="authorizer" width="125"></el-table-column>
      <el-table-column label="投诉内容" align="center">
        <el-table-column label="媒体类型" v-slot="{ row }">{{ mediaTypeMap[row.tortMediaType] }}</el-table-column>
        <el-table-column label="作品名称" prop="tortTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="tortSingerName"></el-table-column>
        <el-table-column label="专辑名" prop="tortAlbumName"></el-table-column>
        <el-table-column label="版本" prop="tortSrcVersion"></el-table-column>
        <el-table-column label="平台" v-slot="{ row }">{{ appealPlatMap[row.tortAppealPlat] }}</el-table-column>
        <el-table-column label="作品链接" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.tortAppealUrl" :href="row.tortAppealUrl" target="_blank">
            {{ row.tortAppealUrl }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="原作品信息" align="center">
        <el-table-column label="作品名称" prop="originTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="originSingerName"></el-table-column>
        <el-table-column label="专辑名" prop="originAlbumName"></el-table-column>
        <el-table-column label="版本" prop="originSrcVersion"></el-table-column>
        <el-table-column label="词作者" prop="originWordAuthor"></el-table-column>
        <el-table-column label="曲作者" prop="originMusicAuthor"></el-table-column>
        <el-table-column label="权利文件" width="200" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.originRightFile" :href="row.originRightFile.fileUrl" :download="row.originRightFile.fileName">
            {{ row.originRightFile.fileName }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160"
        fixed="right"
        align="center"
        v-slot="{ row }"
      >
        <template v-if="isRepeatRole(row) || isComplaintRole(row)">
          <el-button type="text" size="small" @click="handleQuit(row)">放弃权利</el-button>
          <el-button type="text" size="small" @click="handleShowAgree(row)">坚持权利</el-button>
        </template>
        <el-button v-else-if="isLegalRole(row)" type="text" size="small" @click="handleAdvice(row)">意见评估</el-button>
        <template v-else>-</template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.current"
      :page-sizes="[20, 50, 100, 1000, 2000]"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
    >
    </el-pagination>

    <!-- 坚持弹窗 -->
    <upload-right-file-dialog
      ref="uploadRightFileDialog"
      :visible.sync="showRight"
      :loading="saving"
      @confirm="handleAgree"
    ></upload-right-file-dialog>

    <!-- 批量处理弹窗 -->
    <batch-right-dialog
      ref="batchRightDialog"
      :visible.sync="showBatchRight"
      :loading="saving"
      @download="handleDownloadAll"
      @confirm="handleBatchRight"
    ></batch-right-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import { exportTableByColumn, readFileByXlsx } from '@/utils/excel'
import SearchForm from '@/components/SearchForm'

import UploadRightFileDialog from './components/UploadRightFileDialog'
import BatchRightDialog from './components/BatchRightDialog'

import {
  APPEAL_SUB_STATUS,
  MATCH_STATUS,
  mediaTypeMap,
  appealPlatMap,
  appealTypeMap,
  appealSubStatusMap,
  levelOneAppealMap,
  levelTwoAppealMap,
  formatSubOrderDetail
} from '../../const'

import { exportConfig } from './const'

const isUnf = undefined

function defaultSearchParams() {
  return {
    subApplicationOrder: '',
    appealOrder: '',
    appealTitle: '',
    applicationType: isUnf,
    bussType: isUnf,
    complaintType: isUnf,
    subStatus: isUnf,
    applicationTime: '',
    subInsertTime: '',
    applicationUser: '',
    createUser: ''
  }
}

const searchConfigList = [
  {
    label: '申诉子单号',
    key: 'subApplicationOrder',
    type: 'text',
    componentProps: {
      placeholder: '请输入申诉单号',
      clearable: true
    }
  },
  {
    label: '申诉子状态',
    key: 'subStatus',
    type: 'select',
    options: appealSubStatusMap,
    componentProps: {
      clearable: true
    }
  }
]

export default {
  name: 'ConfirmTortList',
  components: {
    SearchForm,
    UploadRightFileDialog,
    BatchRightDialog
  },
  mixins: [paginationTableMixin],
  data() {
    return {
      mediaTypeMap,
      appealPlatMap,
      appealSubStatusMap,
      appealTypeMap,
      levelOneAppealMap,
      levelTwoAppealMap,
      searchConfigList,

      searchParams: defaultSearchParams(),
      showRight: false,
      showBatchRight: false,
      saving: false,
    }
  },
  created() {
    this.handleSearch()
    this.fetchAllConfirmList()
  },
  methods: {
    getParams() {
      const { searchParams } = this
      return searchParams
    },
    async fetchAllConfirmList() {
      try {
        const { list } = await complaintService.queryDetailSubComplaint({
          appealId: +this.$route.query.id,
          subStatus: APPEAL_SUB_STATUS.UNREVIEWED.code,
          page: 0,
          num: 9999
        })
        this.allConfirmList = list
      } catch (error) {
        console.error(error)
      }
    },
    async fetchData() {
      this.loading = true
      const params = this.getParams()
      try {
        const { total, list } = await complaintService.queryDetailSubComplaint({
          ...params,
          appealId: +this.$route.query.id,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = total
        this.tableData = (list || []).map(item => formatSubOrderDetail(item))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    },
    isRepeatRole(row) {
      return row.pkStatus === MATCH_STATUS.NO_FEEDBACK.code
    },
    isComplaintRole(row) {
      return row.pkStatus === MATCH_STATUS.APPEAL_WAIT.code
    },
    isLegalRole(row) {
      return row.pkStatus === MATCH_STATUS.LEGAL_EVALUATE.code
    },
    getPostData(rows, action = 1) { // 1 坚持权利 2 放弃权利
      if (!rows || !rows.length) return null

      return rows.map(row => {
        const { pkId, pkStatus, complaintTrackList: { tracklistId }, repeatRightFileList = [], complaintRightFileList = [] } = row
        const result = { pkId, tracklistId, pkStatus }
        if (this.isRepeatRole(row)) {
          result.pkStatus = action === 1 ? MATCH_STATUS.REPEAT_RIGHT.code : MATCH_STATUS.GIVE_UP.code
          result.rightFile = repeatRightFileList[0]
        } else if (this.isComplaintRole(row)) {
          result.pkStatus = action === 1 ? MATCH_STATUS.APPEAL_RIGHT.code : MATCH_STATUS.APPEAL_GIVE_UP.code
          result.confirmRightFileInfo = complaintRightFileList[0]
        }

        return result
      })
    },
    handleShowBatchRight() {
      this.showBatchRight = true
    },
    async handleDownloadAll() {
      const loadingIns = Loading.service({ fullscreen: true, text: '全量导出中' })
      try {
        if (!this.allConfirmList || !this.allConfirmList.length) {
          await this.fetchAllConfirmList()
        }

        exportTableByColumn(this.allConfirmList, exportConfig, '所有待确认信息导出')
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
      }
      loadingIns.close()
    },
    async handleBatchRight(fileList, rightFileList) {
      // 读取excel内容
      try {
        const list = await readFileByXlsx(fileList[0].raw)
        if (!list || !list.length) return this.$message.error('确认文件内容为空')

        const postData = []
        for (const item of list) {
          const row = this.allConfirmList.find(row => row.pkId === +item['匹配结果ID'])
          const action = item['操作']
          if (!action) continue

          row.action = action.includes('坚持') ? 1 : 2
          const isConfirmAction = row.action === 1
          const rightFile = rightFileList.find(file => file.name === item['权利文件名(需跟作品名称保持一致，含后缀)'])
          if (isConfirmAction && !rightFile) {
            return this.$message.error(`匹配结果ID为 ${row.pkId} 的权利文件未上传或权利文件名称不一致`)
          }

          if (rightFile && isConfirmAction) {
            row[`${this.isRepeatRole(row) ? 'repeatRightFileList' : 'complaintRightFileList'}`] = [rightFile]
          }

          postData.push(...this.getPostData([row], action))
        }

        if (!postData.length) return this.$message.error('所有内容项均为填写操作')

        await this.saveData(postData)
        this.$refs.batchRightDialog.close()
      } catch (error) {
        console.error(error)
        return this.$message.error('文件读取失败')
      }
    },
    async handleQuit(row) {
      try {
        const trackName = this.isRepeatRole(row) ? row.tortTrackName : row.originTrackName
        await this.$confirm(`提交 ${trackName} 作品 <b style="color: red">放弃权利</b><br><b>请再次确认，权利处理结果及权利证明材料完整，一经提交不可修改</b>`, '权利处理确认', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const postData = this.getPostData([row], 2)
        this.saveData(postData)
      } catch (error) {}
    },
    handleShowAgree(row) {
      this.showRight = true
      this.currentRow = row
    },
    async handleAgree(rightFileList) {
      try {
        const trackName = this.isRepeatRole(this.currentRow) ? this.currentRow.tortTrackName : this.currentRow.originTrackName
        await this.$confirm(`提交 ${trackName} 作品 <b style="color: green">坚持权利</b><br><b>请再次确认，权利处理结果及权利证明材料完整，一经提交不可修改</b>`, '权利处理确认', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (this.isRepeatRole(this.currentRow)) {
          this.currentRow.repeatRightFileList = rightFileList
        } else if (this.isComplaintRole(this.currentRow)) {
          this.currentRow.complaintRightFileList = rightFileList
        }
        const postData = this.getPostData([this.currentRow], 1)
        await this.saveData(postData)
        this.$refs.uploadRightFileDialog.close()
      } catch (error) {}
    },
    async handleAdvice(row) {
      try {
        const { value } = await this.$prompt('法务意见评估', '意见评估', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: (val) => {
            if (!val) return '请填写意见'
          },
        })
        const postData = {
          pkId: row.pkId,
          pkStatus: MATCH_STATUS.LEGAL_EVALUATED.code,
          legalAffairs: value
        }
        this.saveData(postData)
      } catch (error) {}
    },

    async saveData(postData) {
      console.log('🚀 ~ file: index.vue:324 ~ saveData ~ postData:', postData)
      this.saving = true
      try {
        await complaintService.saveConfirm(postData)
        this.fetchData()
        this.$message.success('操作成功')
      } catch (error) {
        this.$alert(`保存失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.saving = false
    }
  }
}
</script>

<style lang="scss" scoped>

.search-form {
  ::v-deep {
    .el-card__body {
      padding-bottom: 8px;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 12px;

      .el-form-item__label {
        color: #002444;
      }
    }
  }
}

.table-control {
  margin-bottom: 14px;
}

/deep/ .el-table__cell .cell .el-button + .el-button {
  margin-left: 0;
}
</style>
